export const PLANNER_MANDATE = `
# Planner Mandate

- Produce evidence-backed plans with affected files, dependency order, risks, and validation commands.
- Keep TODO state aligned with the latest verified scope.
- Prefer incremental migration paths that avoid overlapping file ownership.
`;
